import { put, takeLatest } from 'redux-saga/effects';
import { getCCEmails, updateCCEmails } from '../../api/ccEmails';
import parseAxiosError from '../../utils/helpers/parseAxiosError';
import { getCCEmailsActionCreators, updateCCEmailsActionCreators } from '../actions/ccEmailsActionCreators';
import { getCCEmailsConstants, updateCCEmailsConstants } from '../constants/ccEmailsConstants';

function* getCCEmailsSaga() {
  yield put(getCCEmailsActionCreators.pending());
  try {
    const result = yield getCCEmails();
    yield put(getCCEmailsActionCreators.fulfilled(result.data.data));
  } catch (e) {
    yield put(getCCEmailsActionCreators.rejected(parseAxiosError(e)));
  }
}

function* updateCCEmailsSaga({ payload: { emails } }) {
  yield put(updateCCEmailsActionCreators.pending());
  try {
    const result = yield updateCCEmails(emails);
    yield put(updateCCEmailsActionCreators.fulfilled(result.data.data));
  } catch (e) {
    yield put(updateCCEmailsActionCreators.rejected(parseAxiosError(e)));
  }
}

export default function* ccEmailsSagas() {
  yield takeLatest(getCCEmailsConstants.name, getCCEmailsSaga);
  yield takeLatest(updateCCEmailsConstants.name, updateCCEmailsSaga);
}
